<style scoped lang="scss">
    .hardship-reason {
        font-size: 1.2em;
        margin-bottom: 8px;

        display: flex;

        .reason-text {

        }
    }
    .member-hardship-container {
        .member-title {
            font-size: 1.4em !important;
            margin-bottom: 10px;
            font-weight: bold;
        }

        .member-section {
            margin-left: 0px;
        }
    }
    .label-large {
        font-size: 1.3em;
        margin-bottom: 25px;

        display: flex;
        input[type=checkbox] {
            transform: scale(1.3);
            margin-right: 6px;
        }
    }

    .checkbox-container {
        margin-right: 6px;
        height: 100%;
    }

    .vue-dropzone {
        background: #eee;
        border: thin dashed #666;
    }
</style>

<template>
    <div class="uk-form" v-if="application">


        <div class="uk-grid uk-margin-top uk-margin-large-bottom">

            <div class="uk-width-1-1 uk-margin-bottom">
                <h2 class="uk-align-center">
                    {{ application.program.program_abbreviation }} Assistance Request Related to COVID-19 Pandemic
                </h2>
                <p>
                    Since April 1, 2020, I or a member of my household has experienced a hardship due to the Covid-19
                    pandemic.  This hardship was caused by one or more of the following:
                </p>
            </div>

            <div class="uk-width-1-1 member-hardship-container" v-for="(member, i) in hhMembers" v-if="i === 0 || programSettings['requires-all-household-members-hardship-information']">
                <div v-if="programSettings['requires-all-household-members-hardship-information']" class="member-title">Hardship Information for {{ member.first_name }} {{ member.last_name }}</div>
                <div v-else class="member-title">Hardship Information</div>

                <!-- Unemployed -->
                <label class="label-large">
                    <div class="checkbox-container">
                        <input type="checkbox" v-model="member.is_unemployed">
                    </div>
                    <div>
                        I. Since April 1, 2020, a member of my household qualifies for unemployment benefits
                    </div>
                </label>
                <div class="uk-grid uk-margin-bottom uk-margin-top member-section" v-if="member.is_unemployed">
                    <div class="uk-width-1-1">
                        <p></p>
                    </div>
                    <div class="uk-width-small-1-1 uk-width-large-1-4 uk-margin-bottom">
                        <date-picker
                                name="Date Most Recently Unemployed:"
                                label="Date Most Recently Unemployed:"
                                v-model="member.date_unemployed"
                                :config="datePickerConfig"
                                placeholder="Required"
                                rules="required"
                        />
                    </div>
                    <div class="uk-width-small-1-1 uk-width-large-1-4 uk-margin-bottom" v-if="member.date_unemployed">
                        <date-picker
                                name="Applied For Unemployment:"
                                label="Applied For Unemployment:"
                                v-model="member.date_apply_unemployed"
                                :config="datePickerConfig"
                                placeholder="If Applicable"
                        />
                    </div>
                    <div class="uk-width-small-1-1 uk-width-large-1-4 uk-margin-bottom" v-if="member.date_unemployed && member.date_apply_unemployed">
                        <date-picker
                                name="Unemployment Awarded:"
                                label="Unemployment Awarded:"
                                v-model="member.date_award_unemployed"
                                :config="datePickerConfig"
                                placeholder="If Applicable"
                        />
                    </div>
                    <div class="uk-width-small-1-1 uk-width-large-1-4 uk-margin-bottom" v-if="member.date_unemployed && member.date_apply_unemployed && member.date_award_unemployed">
                        <date-picker
                                name="Date Re-employed:"
                                label="Date Re-employed:"
                                v-model="member.date_reemployed"
                                :config="datePickerConfig"
                                placeholder="If Applicable"
                        />
                    </div>
                </div>
                <div class="uk-margin-bottom" v-else></div>
                <!-- / Unemployed -->

                <!-- Covid Hardship -->
                <label class="label-large">
                    <div class="checkbox-container">
                        <input type="checkbox" v-model="member.experienced_covid_hardship">
                    </div>
                    <div>
                        II. Since April 1, 2020, a member of my household has experienced a reduction in household income, incurred significant costs, or experienced other financial hardship due directly or indirectly to the pandemic; however, is unable to document the hardship.  The hardship includes (check all that apply):
                    </div>
                </label>
                <div class="uk-grid uk-margin-bottom uk-margin-small-top member-section" v-if="member.experienced_covid_hardship">
                    <div class="uk-width-1-1">
                        <div class="uk-grid">
                            <div class="uk-width-1-1 hardship-reason" v-for="(reason, reasonKey) in reasons">
                                <div class="checkbox-container">
                                    <input type="checkbox" v-model="member.hardship_reasons" :value="reason.id">
                                </div>
                                <div class="checkbox-description">
                                    <span class="reason-text">{{ reason.body }}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="uk-width-1-1 uk-margin-top">
                        <validated-section :errors="errors" field="hardship_explanation">
                            <label class="font-weight: bold">HARDSHIP EXPLANATION:</label>
                            <p>For applicants certifying to a hardship under section II, please provide additional information explaining your hardship</p>
                            <textarea placeholder="Explain Your Hardship..." v-model="member.hardship_reason_explanation" class="uk-form-large uk-input uk-width-1-1"></textarea>
                        </validated-section>
                    </div>

                    <div class="uk-width-1-1 uk-margin-top">
                        <validated-section :errors="errors" field="hardship_upload">
                            <label class="font-weight: bold">UPLOAD PROOF OF HARDSHIP:</label>
                            <p>Note: You are required to upload proof of hardship if you do not give an explanation above.</p>
                            <p class="uk-text-danger">WARNING: Do NOT Upload Any Medical Documents</p>
                            <validated-section :errors="errors" field="document">
                                <div>
                                    <dropzone-uploader
                                            :dropzone-options="dropzoneOptions"
                                            :form-data="formDataForMember(member)"
                                            @max-files-succeeded="onMaxFilesExceeded"
                                            @onDeleted="documentDeleted"
                                    >
                                        <div class="dropzone-custom-content file-dropzone">
                                            <h3 class="dropzone-custom-title">Drop File Here or Click to Select a File.</h3>
                                        </div>
                                    </dropzone-uploader>
                                </div>
                            </validated-section>

                        </validated-section>
                    </div>
                </div>
                <div class="uk-margin-bottom" v-else></div>
                <!-- / Covid Hardship -->


                <!-- Housing Instability -->
                <!-- <label class="label-large">
                    <div class="checkbox-container">
                        <input type="checkbox" v-model="member.experienced_housing_instability">
                    </div>
                    <div>
                        III. A member of my household has experienced a risk of experiencing homelessness or housing instability; however, is unable to document the risk.  (The hardship does not need to exist as of the date of the application as long as it existed for any period of time since April 1, 2020.  For example, if one member of your household faced a risk or eviction or lived in an overcrowded situation between April 1, 2020 and August 1, 2020, your household would be eligible for MRAP assistance under this eligibility criteria.)
                    </div>
                </label>
                <div class="uk-grid uk-margin-bottom uk-margin-small-top member-section" v-if="member.experienced_housing_instability">
                    <div class="uk-width-1-1 uk-margin-bottom">
                        <p>The hardship includes (check all that apply):</p>
                    </div>
                    <div class="uk-width-1-1">

                        <div class="uk-width-1-1">
                            <div class="uk-grid">
                                <div class="uk-width-1-1 hardship-reason" v-for="(reason, reasonKey) in housingReasons">
                                    <div class="checkbox-container">
                                        <input type="checkbox" v-model="member.housing_hardship_reasons" :value="reason.id">
                                    </div>
                                    <div class="checkbox-description">
                                        <span class="reason-text">{{ reason.body }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="uk-width-1-1 uk-margin-top">
                            <validated-section :errors="errors" field="hardship_explanation">
                                <label class="font-weight: bold">HOUSING INSTABILITY OR HOMELESSNESS RISK EXPLANATION:</label>
                                <p>Other - Please explain: </p>
                                <textarea placeholder="Explain Your Hardship..." v-model="member.housing_hardship_reason_explanation" class="uk-form-large uk-input uk-width-1-1"></textarea>
                            </validated-section>
                        </div>
                    </div>
                    <div class="uk-width-1-1" v-if="false">
                        <div class="uk-margin-top">If You Are Experiencing Any Housing Safety Issues, Choose Them Below</div>
                        <table class="uk-table uk-table-striped">
                            <thead>
                            <tr>
                                <th class="uk-width-3-10">Issue</th>
                                <th class="uk-width-3-10">Details</th>
                                <th class="uk-width-3-10">Notes</th>
                                <th class="uk-width-1-10">&nbsp;</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(findingType,i) in member.finding_types">
                                <td class="uk-width-3-10">
                                    <select v-model="findingType.pivot.finding_type_id" class="uk-select uk-width-1-1">
                                        <option :value="null">Select a Finding Type</option>
                                        <option v-for="type in findingTypes" :value="type.id">{{ type.name }}</option>
                                    </select>
                                </td>
                                <td class="uk-width-3-10">
                                    <select v-if="detailsForFindingTypeId(findingType.pivot.finding_type_id)" v-model="findingType.pivot.finding_type_level" class="uk-select uk-width-1-1">
                                        <option :value="null">Select More Details (Optional)</option>
                                        <option :value="i" v-for="(label, i) in detailsForFindingTypeId(findingType.pivot.finding_type_id)">{{ label }}</option>
                                    </select>
                                </td>
                                <td class="uk-width-3-10">
                                    <textarea class="uk-form-large uk-width-1-1" v-model="findingType.pivot.notes" placeholder="Notes"></textarea>
                                </td>
                                <td class="uk-width-1-10">
                                    <a href="javascript:;" class="uk-icon-button uk-text-danger" @click="member.finding_types.splice(i, 1);">
                                        <i class="a-trash-2"></i>
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="3">
                                    <a href="javascript:;" class="uk-text-large" @click="addFinding(member)">
                                        <i class="a-circle-plus"></i>
                                        Add Safety Issue
                                    </a>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>

                    <div v-if="programSettings['uses-housing-safety-hardship-type']" class="uk-width-1-1 uk-margin-top">
                        <div class="uk-margin-top">If You Are Experiencing Any Housing Safety Issues, Choose Them Below</div>
                        <table class="uk-table uk-table-striped">
                            <thead>
                            <tr>
                                <th class="uk-width-3-10">Issue</th>
                                <th class="uk-width-3-10">Details</th>
                                <th class="uk-width-3-10">Notes</th>
                                <th class="uk-width-1-10">&nbsp;</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(findingType,i) in member.finding_types">
                                <td class="uk-width-3-10">
                                    <select v-model="findingType.pivot.finding_type_id" class="uk-select uk-width-1-1">
                                        <option :value="null">Select a Finding Type</option>
                                        <option v-for="type in findingTypes" :value="type.id">{{ type.name }}</option>
                                    </select>
                                </td>
                                <td class="uk-width-3-10">
                                    <select v-if="detailsForFindingTypeId(findingType.pivot.finding_type_id)" v-model="findingType.pivot.finding_type_level" class="uk-select uk-width-1-1">
                                        <option :value="null">Select More Details (Optional)</option>
                                        <option :value="i" v-for="(label, i) in detailsForFindingTypeId(findingType.pivot.finding_type_id)">{{ label }}</option>
                                    </select>
                                </td>
                                <td class="uk-width-3-10">
                                    <textarea class="uk-form-large uk-width-1-1" v-model="findingType.pivot.notes" placeholder="Notes"></textarea>
                                </td>
                                <td class="uk-width-1-10">
                                    <a href="javascript:;" class="uk-icon-button uk-text-danger" @click="member.finding_types.splice(i, 1);">
                                        <i class="a-trash-2"></i>
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="3">
                                    <a href="javascript:;" class="uk-text-large" @click="addFinding(member)">
                                        <i class="a-circle-plus"></i>
                                        Add Safety Issue
                                    </a>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div> -->
                <div class="uk-margin-bottom" v-else></div>
                <!-- / Housing Instability -->


            </div> <!-- End Member Loop -->
        </div>


        <div class="uk-grid" v-if="applicant">
            <div class="uk-width-small-1-1 uk-width-medium-1-1 uk-width-large-1-2">
                <p class="uk-">
                    Under penalty of perjury, I certify that the information presented in this certification is true and accurate to the best of my knowledge.  I further understand that providing false representations constitutes an act of fraud. False, misleading, or incomplete information may result in the repayment of any funds received through the {{ application.program.program_abbreviation }} Program and other remedies available under applicable law.
                </p>
                <validated-section :field="'signature_'+applicant.id" :errors="errors">
                    <signature-box @updated="onSignatureUpdated"
                                   :user-key="applicant.id"
                                   :is-signed="signatureData[applicant.id] && signatureData[applicant.id].signed_at !== null"
                                   :completed="signatureData[applicant.id] && signatureData[applicant.id].completed"
                                   :name="applicant.first_name + ' ' + applicant.last_name"
                                   :color="programSettings['primary-program-color']"
                    ></signature-box>
                </validated-section>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState, mapGetters} from "vuex";
    import ValidatedSection from "../../../../../components/Common/ValidatedSection";
    import SignatureBox from "../../../../../components/AppWizard/SignatureBox";
    import VueDropzone from 'vue2-dropzone'
    import 'vue2-dropzone/dist/vue2Dropzone.min.css'
    import DropzoneUploader from "../../../../../components/AppWizard/Documents/DropzoneUploader";

    export default {
        name: "CovidHardshipReasons",
        components: {DropzoneUploader, SignatureBox, ValidatedSection, VueDropzone},
        data() {
            return {
                errors: {},
                dropzoneOptions: {
                    url: '/api/hope/documents',
                    thumbnailWidth: 200,
                    addRemoveLinks: true,
                    maxFiles: 1,
                    acceptedFiles: ['.pdf', '.png', '.jpg'].join(','),
                },
                hardshipReasons: [],
                housingHardshipReasons: [],
                hardshipReasonsExplanations: '',
                housingHardshipReasonsExplanations: '',
                signatureData: {},
            }
        },
        computed: {
            ...mapState('Application', {
                application: state => state.application,
                applicant: state => state.applicant,
                hhMembers: state => state.application.household.members,
                findingTypes: state => state.assets.findingTypes,
                reasons: state => state.assets.hardshipReasons,
                housingReasons: state => state.assets.housingReasons,
                signatures: state => state.applicant.signatures,
            }),
            ...mapState('App', {
                env: state => state.env,
            }),
            ...mapGetters('Application', [ 'programSettings' ]),
        },
        watch: {
            application(newValue) {
                if(newValue) {
                    this.initData();
                }
            }
        },
        mounted() {
            if(this.application) {
                this.initData();
            }
        },
        methods: {
            initData() {
                const signatureFiltered = this.signatures.find(item => item.key === `app-hardship`)
                if(signatureFiltered) {
                    this.$set(this.signatureData, this.applicant.id, { signed_at: signatureFiltered.created_at, completed: true });
                }
            },

            addFinding(member) {
                member.finding_types.push({
                    pivot: {
                        finding_type_id: null,
                        finding_type_level: null,
                        household_application_id: this.application.id,
                        household_member_id: member.id,
                        household_id: member.household_id,
                        notes: '',
                    }
                })
            },

            getFindingTypeForId(id) {
                for(var i in this.findingTypes) {
                    if(this.findingTypes[i].id === id) {
                        return this.findingTypes[i];
                    }
                }
                return null;
            },
            detailsForFindingTypeId(id) {
                let details = {};
                let finding = this.getFindingTypeForId(id);
                if(!finding) return null;
                if(finding.one) {
                    details[1] = finding.one_description;
                }
                if(finding.two) {
                    details[1] = finding.two_description;
                }
                if(finding.three) {
                    details[1] = finding.three_description;
                }
                return details;
            },

            formDataForMember(member) {
                return {
                    household_application_id: this.application.id,
                    household_member_id: member.id,
                    applicant_user_id: this.application.applicant_user_id,
                    file_type: 'proof_of_hardship',
                }
            },
            onMaxFilesExceeded(file) {
                console.log('max files exceeded', file);
            },
            onSignatureUpdated($event) {
                if(!this.signatureData[$event.key]) {
                    this.$set(this.signatureData, $event.key, {});
                }
                this.$set(this.signatureData, $event.key, { signed_at: $event.isSigned ? moment().format('YYYY-MM-DD HH:mm') : null});
            },
            async validateStep() {
                this.errors = {};
                // if(this.application.hardship_reasons.length === 0 && !this.hardship_reason_other) {
                //     this.errors['reasons'] = { errors: ['You must provide at least one reason for hardship.']};
                // }
                //
                //
                if(!this.signatureData[this.applicant.id]) {
                    this.errors['signature_'+this.applicant.id] = {
                        errors: [this.applicant.first_name + ' ' + this.applicant.last_name + ' must sign this form as their name appears above.'],
                    };
                }else if(this.signatureData[this.applicant.id] && this.signatureData[this.applicant.id].signed_at == null) {
                    this.errors['signature_'+this.applicant.id] = {
                        errors: [this.applicant.first_name + ' ' + this.applicant.last_name + ' must sign this form as their name appears above.'],
                    };
                }

                let errorCount = _.size(this.errors);

                if(errorCount > 0) return false;


                // Server Side Validation
                try {
                    let response = await this.save();
                    return true;
                }catch(err) {
                    console.error(err);
                }

            },
            async save() {

                let _members = _.map(this.application.household.members, member => _.pick(member, [
                    'id',
                    'is_unemployed',
                    'date_unemployed',
                    'date_apply_unemployed',
                    'date_award_unemployed',
                    'date_reemployed',
                    'experienced_covid_hardship',
                    'hardship_reasons',
                    'hardship_reason_explanation',
                    'experienced_housing_instability',
                    'housing_hardship_reasons',
                    'housing_hardship_reason_explanation',
                    'finding_types',
                ]))

                let data = {
                    signatures: this.signatureData,
                    members: _members,
                }
                return await axios.put(`/api/hope/applications/${this.application.id}/step-hardship-reason`, data)
            },
        }
    }
</script>
